import { render } from "./OptionsOrgType.vue?vue&type=template&id=93853e4e"
import script from "./OptionsOrgType.vue?vue&type=script&lang=js"
export * from "./OptionsOrgType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__